module.exports = __webpack_public_path__ + "static/media/ar_letter_red.104231f1.png";